import { render, staticRenderFns } from "./IdeasEmail.vue?vue&type=template&id=8ae40632&scoped=true&"
import script from "./IdeasEmail.vue?vue&type=script&lang=js&"
export * from "./IdeasEmail.vue?vue&type=script&lang=js&"
import style0 from "./IdeasEmail.vue?vue&type=style&index=0&id=8ae40632&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ae40632",
  null
  
)

export default component.exports